import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig, RestActionType } from '@intelliarts/ia-react-template';

import authConfig, { HR_MENU_GROUP } from '../../../config/authConfig';
import { RISKS_PAGE_LOCALE_PATH } from '../../Employee/locales';
import { risksActions, RisksStore } from '../store/risksStore';
import { employeeActions, EmployeesStore } from '../../Employee/store/employeesStore';
import { ProjectsStore } from '../../Project/store/projectsStore';
import { riskLevelsActions, RiskLevelsStore } from '../../Configuration/store/riskLevelsStore';
import { riskReasonsActions, RiskReasonsStore } from '../../Configuration/store/riskReasonsStore';
import { riskStatusesActions, RiskStatusesStore } from '../../Configuration/store/riskStatusesStore';
import { riskLifecycleStagesActions, RiskLifecycleStagesStore } from '../../Configuration/store/riskLifecycleStagesStore';
import { riskExpectationsActions, RiskExpectationsStore } from '../../Configuration/store/riskExpectationsStore';
import { RiskAlumniStore } from '../../Employee/store/riskAlumniStore';
import { riskResolutionOutcomesActions, RiskResolutionOutcomesStore } from '../../Configuration/store/riskResolutionOutcomesStore';
import { assigneesActions, AssigneesStore } from '../store/assigneesStore';

export const RisksRoutes = {
  default: 'risks',
};

export const RisksPageConfig: ReactPageConfig = {
  name: `${RISKS_PAGE_LOCALE_PATH}.pageConfig.name`,
  path: RisksRoutes.default,
  allowedRoles: [authConfig.roles.ADMIN],
  component: lazy(() => import('../components/RisksPage')),
  storeDependencies: [
    { store: RisksStore, onContainerInitAction: risksActions[RestActionType.GET] },
    { store: EmployeesStore, onContainerInitAction: employeeActions.loadActiveEmployees },
    { store: ProjectsStore },
    { store: RiskLevelsStore, onContainerInitAction: riskLevelsActions[RestActionType.GET] },
    { store: RiskReasonsStore, onContainerInitAction: riskReasonsActions[RestActionType.GET] },
    { store: RiskStatusesStore, onContainerInitAction: riskStatusesActions[RestActionType.GET] },
    { store: RiskLifecycleStagesStore, onContainerInitAction: riskLifecycleStagesActions[RestActionType.GET] },
    { store: RiskExpectationsStore, onContainerInitAction: riskExpectationsActions[RestActionType.GET] },
    { store: RiskAlumniStore },
    { store: RiskResolutionOutcomesStore, onContainerInitAction: riskResolutionOutcomesActions[RestActionType.GET] },
    { store: AssigneesStore, onContainerInitAction: assigneesActions.loadAssignees },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/WarningAmberOutlined')),
    label: `${RISKS_PAGE_LOCALE_PATH}.pageConfig.label`,
    group: HR_MENU_GROUP,
    isCollapsibleGroup: true,
  }),
};
